// extracted by mini-css-extract-plugin
export default {"list_item":"panel-list_list_item__Svsa0","panel_hr":"panel-list_panel_hr__Albrl","mobile":"panel-list_mobile__64+4I"};